<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->

		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page="selected_page"></rosidebar>
				<div
					style="float: right;width:calc(100% - 269px);overflow: auto;height:1090px;background: white;border-radius: 5px;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
						<!-- 您的位置： -->
						<!-- <span style="color:gray;">首页</span> > <span style="color:gray;">个人中心</span> > -->
						<span style="color:#07ccec;">个人信息</span>
					</h6>
					<div style="width: 95%;margin:20px auto;padding:0 10px;border: 2px dotted #F0F0F0;height: 50px;">

						<el-button size="small" style="float: left;margin-top: 8px;background-color: red;color:white;"
							@click="turn_to_new_info()">新增个人信息</el-button>
							<el-button size="small" style="float: left;margin-top: 8px;background-color: red;color:white;"
								@click="turn_to_user_info()">修改账户信息</el-button>
						<el-pagination style="float: right;margin-top: 8px;" :page-sizes="[5, 10]" :page-size="5"
							layout="sizes, prev, pager, next" :total="totalCount">
						</el-pagination>
					</div>
					<el-table :data="address_datas" style="width: 95%;margin:30px auto;" stripe>
						<el-table-column fixed prop="unit_name" label="单位名称" width="150">
						</el-table-column>
						<el-table-column prop="contact" label="委托人" width="150">
						</el-table-column>
						<el-table-column prop="contact_mobile" label="手机号码" width="120">
						</el-table-column>
						<el-table-column prop="contact_phone" label="座机(选填)" width="120">
						</el-table-column>
						<el-table-column prop="address" label="通讯地址" width="310">
						</el-table-column>
						<el-table-column prop="postcode" label="邮编(选填)" width="120">
						</el-table-column>
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="150">
							<template slot-scope="scope">
								<a style="margin-right:10px;">
									<el-button @click="turn_to_change_info(scope.row)" type="success" size="small">修改
									</el-button>
								</a>
								<el-button type="danger" size="small" @click="delete_info(scope.row)">删除</el-button>
								<!-- <el-button type="text" size="small">设为默认</el-button> -->
							</template>
						</el-table-column>
					</el-table>
					<!-- 			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="pageSizes" :page-size="PageSize" background
						layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
					</el-pagination> -->
				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'user_infor',
		data() {
			return {
				tableData: [],
				address_datas: [],
				currentPage: 1,
				// 总条数，根据接口获取数据长度(注意：这里不能为空)
				totalCount: 40,
				// 个数选择器（可修改）
				pageSizes: [10, 20, 40, 80],
				// 默认每页显示的条数（可修改）
				PageSize: 20,
				selected_page: '1-2',
			}
		},
		mounted() {
			this.get_address_data()
			// var self = this
			// fetchGet('/ro/report_data_center/fcst/datas/sale').then(function(data) {
			// 	// debugger;
			// 	self.customer_options = data.data['partner_data']
			// 	self.product_options = data.data['product_data']
			// 	// self.tableData = data.data['partner_data']
			// 	console.log(self.tableData)

			// })


			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {	
			turn_to_new_info() {
				this.$router.push('/user/new_infor')
			},
			turn_to_user_info(){
					this.$router.push('/home/reset')
			},
			handleClose(done) {
				var self = this
				this.$confirm('确认删除？')
					.then(_ => {
						console.log('slslslsl')
						var data = {
							'id': self.now_select_address_info.id
						}
						fetchPost('/ro/tec_search/user/info/delete/v1', data).then(response => {
							if(response.data.result=='session_expired'){
								window.location.href='/#/pages/login'
							}
							
							if(response.data.result =='fail'){
								self.$message.error(response.data.reason)
							}
							self.get_address_data()
						})
					})
					.catch(_ => {});
			},
			handleCurrentChange(val) {
				console.log(val)
				console.log('handleCurrentChange')
				this.currentPage = val
				this.get_address_data()
			},

			handleSizeChange(val) {
				console.log(val)
				console.log('handleSizeChange')
				this.PageSize = val
				this.get_address_data()
			},

			turn_to_change_info(row) {
				// #/user/change_infor
				console.log(row);
				window.localStorage.setItem('now_select_address_info', JSON.stringify(row))
				this.$router.push('/user/change_infor')
			},
			delete_info(row) {

				var self = this
				this.now_select_address_info = row
				self.handleClose()


			},
			get_address_data() {
				var data = {
					'id': window.localStorage.getItem('user_id'),
					'page': this.currentPage,
					'page_size': this.PageSize,
				}
				// debugger
				var self = this
				fetchPost('/ro/tec_search/user/info/list/v1', data).then(response => {
					console.log(response)
if(response.data.result=='session_expired'){
						window.location.href='/#/pages/login'
					}
					self.address_datas = response.data.list
					self.totalCount = response.data.total

				})
			},

		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}

	.el-table th {
		text-align: center !important;
		background-color: #F0F0F0;
		color: #333;
	}

	.el-table td {
		text-align: center !important;
	}
</style>
